module.exports = __webpack_public_path__ + "img/what3words.72e36176.svg";